import React, { Fragment } from "react";
import Footer2 from "../components/Footer2";
import ResponsiveHeader from "../components/ResponsiveHeader";

// import "./styles.css";
const ExpertsTips = () => {
  return (
    <Fragment>
      <ResponsiveHeader />
      <div className="row-negro">
        <h2 className="text-center text-white">
          Tips de expertos — Amortiguadores
        </h2>
      </div>
      <main className="container">
        <header className="hero text-center">
          <h2 className="title"></h2>
          <p className="subtitle">
            Consejos clave para alargar la vida útil del sistema de suspensión.
          </p>
        </header>

        <section className="tips-grid">
          <div className="d-flex">
            <div className="col-md-4 m-2">
              <article className="tip-card   ">
                <div className="tip-media">
                  <img
                    src={window.location.origin + "/tip_1.jpg"}
                    alt="Mecánico trabajando en suspensión"
                    className="tip-image"
                  />
                </div>
                <div className="tip-badge">1</div>
                <h3 className="tip-title">
                  Tus amortiguadores tienen una vida útil predefinida
                </h3>
                <p className="tip-text">
                  Como siempre que se habla de refacciones de tu auto, todo
                  dependerá de qué uso les des, ya que no es lo mismo ocuparlo
                  como vehículo personal o para tu trabajo. En este caso debemos
                  tener muy en cuenta el terreno donde transita habitualmente
                  nuestro vehículo, así como la velocidad del trayecto. En
                  condiciones normales, los amortiguadores de fábrica de tu auto
                  deberían darte una vida útil que va de los 60,000 a los
                  100,000 kilómetros. Es decir, después de este lapso, conviene
                  empezar a buscar opciones para reemplazarlos.
                </p>
                <ul className="tip-list">
                  <li>
                    <span className="label">
                      <strong>Uso y entorno:</strong>
                    </span>
                    Considera terreno y velocidad en el día a día.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Rango de vida útil:</strong>
                    </span>
                    60,000 a 100,000 km en condiciones normales.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Acción sugerida:</strong>
                    </span>
                    Evalúa reemplazo al alcanzar el rango.
                  </li>
                </ul>
              </article>
            </div>

            <div className="col-md-4 m-2">
              <article className="tip-card">
                <div className="tip-media">
                  <img
                    src={window.location.origin + "/tip_2.jpg"}
                    alt="Mecánico trabajando en suspensión"
                    className="tip-image"
                  />
                </div>
                <div className="tip-badge">2</div>
                <h3 className="tip-title">
                  No excedas el límite del peso del auto
                </h3>
                <p className="tip-text">
                  Todos los vehículos automotores tienen un manual de uso que es
                  importante seguir en todo momento. Para el caso del peso del
                  automóvil deben tenerse en cuenta la capacidad máxima, MMA
                  (masa máxima autorizada), que en promedio es de 400 a 600
                  kilogramos. Esto nos puede dar un estimado de cuánto podemos
                  cargar en el equipaje. Si el auto lleva una sola persona, el
                  peso restante puede ser de carga; en cambio, si se transportan
                  5 personas, la capacidad de equipaje disminuye
                  considerablemente.
                </p>
                <ul className="tip-list">
                  <li>
                    <span className="label">
                      <strong>MMA promedio:</strong>
                    </span>
                    400 a 600 kg.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Distribución del peso:</strong>
                    </span>
                    Menos equipaje cuando viajan más personas.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Recomendación:</strong>
                    </span>
                    Consulta y respeta el manual del fabricante.
                  </li>
                </ul>
              </article>
            </div>
            <div className="col-md-4 m-2">
              <article className="tip-card">
                <div className="tip-media">
                  <img
                    src={window.location.origin + "/tip_3.jpg"}
                    alt="Mecánico trabajando en suspensión"
                    className="tip-image"
                  />
                </div>
                <div className="tip-badge">3</div>
                <h3 className="tip-title">Realiza una inspección periódica</h3>
                <p className="tip-text">
                  Los aspectos preventivos son de suma importancia para evitar
                  fallas en el sistema de suspensión. Una revisión visual del
                  estado de tus amortiguadores puede ayudar a prevenir problemas
                  futuros. Mediante una inspección podrás verificar fácilmente
                  si los amortiguadores se encuentran en buen estado. Revisa
                  que:
                </p>
                <ul className="tip-list">
                  <li>
                    <span className="label">
                      <strong>Fugas:</strong>
                    </span>
                    Los amortiguadores no estén derramando líquido.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Resortes:</strong>
                    </span>
                    No haya resortes rotos.
                  </li>
                  <li>
                    <span className="label">
                      <strong>Fijaciones:</strong>
                    </span>
                    Tornillos y anclajes bien ajustados al sistema de
                    suspensión.
                  </li>
                </ul>
              </article>
            </div>
          </div>
        </section>
      </main>

      <Footer2 />
    </Fragment>
  );
};
export default ExpertsTips;
